export const alertConstatnt = {
    ALERTING: 'ALERTING',
    ALERTINGMESSAGE: 'ALERTINGMESSAGE',
    SESSIONOUT: 'SESSIONOUT',
    CLOSE: 'CLOSE'
}